import { IconAlertCircle } from '@iwoca/icons';

import { TSpendingLimitType } from '../../../hooks/useGetSpendingLimits';
import { formatCurrency } from '../../../utils/currency';
import {
  formatDuration,
  mapSellerProductToDurationInMonths,
} from '../../SpendingLimitCard/components/duration.helpers';

export const UnavailableLimit = ({
  sellerProduct,
}: {
  sellerProduct: TSpendingLimitType;
}) => {
  const durationInMonths = mapSellerProductToDurationInMonths({
    sellerProduct: sellerProduct,
  });

  return (
    <div>
      <div className="text-base mb-s">
        {formatDuration({ duration: durationInMonths! })} purchases
      </div>
      <div className="mb-xs text-xs font-reg">Left to spend:</div>
      <div
        className="gap-1 mb-xs flex text-xl"
        title="We can't approve you for more funds right now — check back in 30 days and hit 'Secure my limit'."
      >
        {formatCurrency(0)}
        <span
          className="ml-xs cursor-help text-s text-structure-60"
          title="We can't approve you for more funds right now — check back in 30 days and hit 'Secure my limit'."
        >
          <IconAlertCircle className="fill-current h-[24px] w-[24px] shrink-0 text-structure-60" />
        </span>
      </div>
    </div>
  );
};
